import { create } from 'zustand';

import { type ErrorCode } from '@/components/ErrorOverlay/errorConfigs';

interface ErrorState {
  code: ErrorCode;
  targetId?: string;
}

interface Store {
  errors: ErrorState[];
  addError: (error: ErrorState) => void;
  clearErrors: () => void;
}

export const useErrorStore = create<Store>((set) => ({
  errors: [],
  addError: (error) => {
    set((state) => ({ errors: [...state.errors, error] }));
  },
  clearErrors: () => {
    set({ errors: [] });
  },
}));
